import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { altreNotLibriSocialiLibriSocialiRules } from './altre-not-libri-soc-libri-sociali.rules';
import { altreNotLibriSocialiOrganoContrRules } from './altre-not-libri-soc-organo-contr.rules';
import { altreNotLibriSocialiAllegatiRules } from './altre-not-libri-soc-allegati.rules';

export const altreNotLibriSocialiRules: FormGroupRules = {
    ...altreNotLibriSocialiLibriSocialiRules,
    ...altreNotLibriSocialiOrganoContrRules,
    ...altreNotLibriSocialiAllegatiRules,
};

export const AltreNotLibriSocialiFormValidators = Object.values(altreNotLibriSocialiRules);
